module.exports = __webpack_public_path__ + "static/img/img_support-header.44b53bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top/img_support-header.svg
// module id = 367
// module chunks = 2